var _Asterisk, _CircleCheck, _AlertTriangle;
import clsx from 'clsx';
import * as React from 'react';
import { Asterisk, AlertTriangle, CircleCheck } from '@ovpn-ui/icons';
import useValueProp from '../_internal/hooks/useValueProp';
import StyledInput from '../_internal/components/StyledInput';
import maybeElementId from '../_internal/utils/maybeElementId';
import InputContainer from '../_internal/components/InputContainer';
import { Label, LabelContainer } from '../_internal/components/InputLabel';
import { Description, DescriptionContainer } from '../_internal/components/InputDescription';
import * as Styled from './Input.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Input(props, ref) {
  const {
    color = 'default',
    children,
    title,
    description,
    required,
    id,
    style,
    error = false,
    success = false,
    warning = false,
    className,
    iconLeft,
    iconRight,
    tooltip,
    prefix,
    suffix,
    disabled,
    autoFocus,
    flex,
    inline,
    center,
    m,
    mb,
    mt,
    ml,
    mr,
    p,
    pb,
    pt,
    pl,
    pr,
    'data-testid': dataTestId,
    ...htmlAttributes
  } = props;
  const {
    value,
    onChange
  } = useValueProp(props);
  return /*#__PURE__*/_jsxs(Styled.Container, {
    forwardedAs: "label",
    className: clsx('ovpn-input-parent', className),
    "data-invalid": error || warning || undefined,
    "data-testid": dataTestId,
    flex: flex,
    inline: inline,
    center: center,
    m: m,
    mb: mb,
    mt: mt,
    ml: ml,
    mr: mr,
    p: p,
    pb: pb,
    pt: pt,
    pl: pl,
    pr: pr,
    style: style,
    children: [!!title && /*#__PURE__*/_jsxs(LabelContainer, {
      children: [/*#__PURE__*/_jsxs(Label, {
        ...maybeElementId(id, 'input-label'),
        children: [title, required && (_Asterisk || (_Asterisk = /*#__PURE__*/_jsx(Asterisk, {
          size: 15
        })))]
      }), required === false && 'Optional']
    }), /*#__PURE__*/_jsx(InputContainer, {
      error: !!error,
      ref: ref,
      ...htmlAttributes,
      onChange: onChange,
      value: value,
      iconLeft: iconLeft,
      iconRight: iconRight,
      tooltip: tooltip,
      prefix: prefix,
      suffix: suffix,
      disabled: disabled,
      autoFocus: autoFocus,
      children: !children ? /*#__PURE__*/_jsx(StyledInput, {
        ...maybeElementId(id)
      }) : children
    }), !!description && /*#__PURE__*/_jsxs(DescriptionContainer, {
      success: success,
      warning: warning,
      error: !!error,
      children: [success && (_CircleCheck || (_CircleCheck = /*#__PURE__*/_jsx(CircleCheck, {
        className: "ovpn-input-description-icon"
      }))), (error || warning) && (_AlertTriangle || (_AlertTriangle = /*#__PURE__*/_jsx(AlertTriangle, {
        className: "ovpn-input-description-icon"
      }))), /*#__PURE__*/_jsxs(Description, {
        color: color,
        ...maybeElementId(id, 'description'),
        children: [' ', description]
      })]
    })]
  });
}
export default /*#__PURE__*/React.forwardRef(Input);